import React from 'react';
import styled from 'styled-components';
import Fade from 'react-reveal/Fade';
import { FaGithub, FaLinkedin, FaTwitter } from 'react-icons/fa';
import FooterCol from './FooterCol';
import PText from './PText';

const FooterStyle = styled.div`
  background-color: var(--deep-dark);
  padding-top: 10rem;
  .container {
    display: flex;
    gap: 3.5rem;
  }
  .footer__col1 {
    flex: 2;
    .para {
      margin: 0;
    }
  }
  .footer__col3,
  .footer__col4 {
    flex: 1;
    margin-left: 2rem;
    .link li {
      display: inline-block;
    }
  }
  .footer__col1__title {
    font-size: 3.5rem;
    margin-bottom: 1rem;
  }
  .copyright {
    background-color: var(--dark-bg);
    text-align: left;
    padding: 1rem 0;
    margin-top: 5rem;
    .para {
      display: flex;
      justify-content: center;
      .highlight {
        background: none;
        font-weight: 700;
      }
    }
  }
  @media only screen and (max-width: 768px) {
    .container {
      flex-direction: column;
      gap: 0rem;
      & > div {
        margin-top: 5rem;
      }
    }
    .footer__col1 .para {
      max-width: 100%;
    }
    .copyright {
      .container {
        div {
          margin-top: 0;
        }
      }
    }
  }
`;

export default function Footer() {
  return (
    <Fade>
      <FooterStyle>
        <div className="container">
          <div className="footer__col1">
            <h1 className="footer__col1__title">Aniket Pathak</h1>
            <PText>
              A self-taught, highly motivated, and aspiring developer who enjoys
              dabbling in various IT fields and am always up for a new
              challenge.
            </PText>
          </div>
          <div className="footer__col3">
            <FooterCol
              heading="Contact Info"
              links={[
                {
                  title: '6291513445',
                  path: '',
                },
                {
                  title: 'aniketpathak028@gmail.com',
                  path: '',
                },
                {
                  title: 'Narendrapur Kolkata West-Bengal India 700103',
                  path: 'http://google.com/maps',
                },
              ]}
            />
          </div>
          <div className="footer__col4">
            <FooterCol
              heading="Social Links"
              links={[
                {
                  title: (
                    <FaLinkedin
                      style={{
                        height: '40px',
                        width: '40px',
                        marginRight: '10px',
                      }}
                    />
                  ),
                  path: 'https://www.linkedin.com/in/aniket-pathak-8925311b5/',
                },
                {
                  title: (
                    <FaTwitter
                      style={{
                        height: '40px',
                        width: '40px',
                        marginRight: '10px',
                      }}
                    />
                  ),
                  path: 'https://twitter.com/AniketP51335534',
                },
                {
                  title: (
                    <FaGithub
                      style={{
                        height: '40px',
                        width: '40px',
                        marginRight: '10px',
                      }}
                    />
                  ),
                  path: 'https://github.com/aniketpathak028',
                },
              ]}
            />
          </div>
        </div>
        <div className="copyright">
          <div className="container">
            <PText>© 2022 - Aniket Pathak</PText>
          </div>
        </div>
      </FooterStyle>
    </Fade>
  );
}
